import React from 'react';

import { HrisImportLog } from '../../typescript-types/hris-import-log';
import { UiDialog } from '../../ui/ui-dialog';

import { HrisEmployeeDiffTable } from './hris-employee-diff-table';

import { formatDateTimeShort } from '../../util/formatters';
import { getEmployeeChangeLogCountForOrg } from '../util/get-employee-change-log-counts';

type HrisEmployeeDiffDialogProps = {
  hrisImportLog: HrisImportLog;
  filterForOrgId: number | null;
  onClose: () => void;
};

export const HrisEmployeeDiffDialog = ({
  hrisImportLog,
  filterForOrgId,
  onClose,
}: HrisEmployeeDiffDialogProps) => {
  const { countOfEmployeeChangeLogs, finishedAt } = hrisImportLog;
  const employeeChangeLogCount = getEmployeeChangeLogCountForOrg(
    countOfEmployeeChangeLogs,
    filterForOrgId,
  );
  return (
    <UiDialog
      size="lg"
      title={`${employeeChangeLogCount} Employee Changes on ${formatDateTimeShort(finishedAt)}`}
      onClose={onClose}
    >
      <UiDialog.Content>
        <HrisEmployeeDiffTable
          hrisImportLogId={hrisImportLog.hrisImportLogId}
          filterForOrgId={filterForOrgId}
        />
      </UiDialog.Content>
    </UiDialog>
  );
};
